import React, {useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {logout} from "@/actions/auth";

const Logout: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const form = useRef<any>();

    useEffect(() => {
        if(form.current) {
            (form.current as HTMLFormElement).submit();
            logout()(dispatch);
        }
    }, [form]);
  return <form ref={form} method={'post'} action={'/logout'} />;
}

export default Logout;
